import { useState } from "react";
import { LandingPage } from "./pages/LandingPage";
import { DemoPage } from "./pages/DemoPage";

export type Page = "landing" | "demo";

export default function App() {
  const [page, setPage] = useState<Page>("landing");

  return page === "landing"
    ? <LandingPage onDemo={() => setPage("demo")} />
    : <DemoPage onBack={() => setPage("landing")} />;
}
